/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiPublicSiteDtoPublicPaymentYearDto } from './WebApiPublicSiteDtoPublicPaymentYearDto';
import {
    WebApiPublicSiteDtoPublicPaymentYearDtoFromJSON,
    WebApiPublicSiteDtoPublicPaymentYearDtoFromJSONTyped,
    WebApiPublicSiteDtoPublicPaymentYearDtoToJSON,
} from './WebApiPublicSiteDtoPublicPaymentYearDto';

/**
 * The logged-in member's membership payment status per year, as shown on the public site.
 * @export
 * @interface WebApiPublicSiteDtoPublicMemberPaymentsDto
 */
export interface WebApiPublicSiteDtoPublicMemberPaymentsDto {
    /**
     * 
     * @type {Array<WebApiPublicSiteDtoPublicPaymentYearDto>}
     * @memberof WebApiPublicSiteDtoPublicMemberPaymentsDto
     */
    years?: Array<WebApiPublicSiteDtoPublicPaymentYearDto> | null;
}

/**
 * Check if a given object implements the WebApiPublicSiteDtoPublicMemberPaymentsDto interface.
 */
export function instanceOfWebApiPublicSiteDtoPublicMemberPaymentsDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiPublicSiteDtoPublicMemberPaymentsDtoFromJSON(json: any): WebApiPublicSiteDtoPublicMemberPaymentsDto {
    return WebApiPublicSiteDtoPublicMemberPaymentsDtoFromJSONTyped(json, false);
}

export function WebApiPublicSiteDtoPublicMemberPaymentsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiPublicSiteDtoPublicMemberPaymentsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'years': !exists(json, 'years') ? undefined : (json['years'] === null ? null : (json['years'] as Array<any>).map(WebApiPublicSiteDtoPublicPaymentYearDtoFromJSON)),
    };
}

export function WebApiPublicSiteDtoPublicMemberPaymentsDtoToJSON(value?: WebApiPublicSiteDtoPublicMemberPaymentsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'years': value.years === undefined ? undefined : (value.years === null ? null : (value.years as Array<any>).map(WebApiPublicSiteDtoPublicPaymentYearDtoToJSON)),
    };
}

